import axios from 'axios';
import Metadata from '../helpers/metadata/Metadata';
import recordDescriptorProcessing from '../helpers/StoreFunctions/recordDescriptorProcessing';
import serviceUtil from './serviceUtil';

// Request deduplication cache
const requestCache = new Map();

let helpers = {
  createTeam(team, eventMetadatum, options) {
    delete team._recordState;
    let markets = team.markets ? team.markets.map(market => {
      return { id: market.id, name: market.name, code: market.code };
    }) : null;
    
    let lead_user = team.lead_user ? { id: team.lead_user.id, first_name: team.lead_user.first_name, last_name: team.lead_user.last_mame } : null;
    
    delete team.markets;
    team.lead_user = lead_user;

    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const url = `${process.env.REACT_APP_API}/teams?current_company=${localStorage.current_company_id}` +
      (options && options.recordDescriptor ? ('&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : '');
    return axios({
      method: 'post',
      url: url,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        team: team,
        markets: markets,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  updateTeam(team, eventMetadatum, options){
    delete team._recordState;
    let markets = team.markets ? team.markets.map(market => {
      return { id: market.id, name: market.name, code: market.code };
    }) : null;
    let lead_user = team.lead_user ? { id: team.lead_user.id, first_name: team.lead_user.first_name, last_name: team.lead_user.last_mame } : null;

    delete team.markets;
    team.lead_user = lead_user;
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const url = `${process.env.REACT_APP_API}/teams/${team.id}?current_company=${localStorage.current_company_id}`
       + (options && options.recordDescriptor ? ('&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : '');
    return axios({
      method: 'patch',
      url: url,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        team: team,
        markets: markets,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  deleteTeamLogo(team_id, eventMetadatum, options) {
    const url = `${process.env.REACT_APP_API}/teams/${team_id}/delete_logo?current_company=${localStorage.current_company_id}`
       + (options && options.recordDescriptor ? ('&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : '');
    return axios({
      method: 'delete',
      url: url,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  deleteTeam(team_id, eventMetadatum){
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: `${process.env.REACT_APP_API}/teams/${team_id}?current_company=${localStorage.current_company_id}`,
      data: {
        event_metadatum: eventMetadatum,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  getTeams(company_id, market_id, options){
    const url = `${process.env.REACT_APP_API}/teams/?current_company=${company_id ? company_id : localStorage.current_company_id}`
      + (options && options.recordDescriptor ? ('&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : '')
      + (market_id ? ('&market_id=' + market_id) : '');

    // Check if identical request is already in progress
    const cacheKey = url;
    if (requestCache.has(cacheKey)) {
      return requestCache.get(cacheKey);
    }

    const requestPromise = axios({
      method: 'get',
      url,
      timeout: 60000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      requestCache.delete(cacheKey);
      return response.data;
    })
    .catch(error => {
      requestCache.delete(cacheKey);
      return serviceUtil.resultForError(error);
    });

    requestCache.set(cacheKey, requestPromise);
    return requestPromise;
  },
  getTeam(team_id, company_id, options) {
    let url;
    if (options) {
      url = `${process.env.REACT_APP_API}/teams/${team_id}?current_company=${company_id ? company_id : localStorage.current_company_id}`;
      if (options.recordDescriptor){
        url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
      }
    }
    else {
      url = `${process.env.REACT_APP_API}/teams/${team_id}?current_company=${company_id ? company_id : localStorage.current_company_id}`; 
    }
    return axios({
      method: 'get',
      url: url,
      timeout: 60000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        if (options) {
          return response.data;
        }
        else {
          return response.data.data;
        }
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  bulkAddUsersToTeam(teamId, userIds, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const url = `${process.env.REACT_APP_API}/teams/${teamId}/bulk_add_users?current_company=${localStorage.current_company_id}` +
      (options && options.recordDescriptor ? ('&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : '');
    return axios({
      method: 'post',
      url: url,
      timeout: 60000,
      headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        user_ids: userIds,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  bulkAddProjectsToTeam(teamId, payload, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const url = `${process.env.REACT_APP_API}/teams/${teamId}/bulk_add_projects?current_company=${localStorage.current_company_id}` +
      (options && options.recordDescriptor ? ('&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : '');
    const body = {
      event_metadatum: eventMetadatum,
      project_id: payload.project_id,
      project_ids: payload.project_ids,
      markets: payload.markets && payload.markets.length ? payload.markets.map(m => { return m.id; }).join(',') : null,
      project_managers: payload.project_managers && payload.project_managers.length ? payload.project_managers.map(pm => { return pm.id; }).join(',') : null,
      project_types: payload.project_types && payload.project_types.length ? payload.project_types.map(pt => { return pt.id; }).join(',') : null,
    };
    return axios({
      method: 'post',
      url: url,
      timeout: 60000,
      headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: body,
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  addUserToTeam(userId, teamId, eventMetadatum){
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_API}/teams/${teamId}/add_user?current_company=${localStorage.current_company_id}`,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        user_id: userId,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  deleteUserFromTeam(userId, teamId, eventMetadatum){
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: `${process.env.REACT_APP_API}/teams/${teamId}/remove_user?current_company=${localStorage.current_company_id}`,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        user_id: userId,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  addProjectToTeam(projectId, teamId, eventMetadatum, markets, project_managers, project_types, options){
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_API}/teams/${teamId}/add_project?current_company=${localStorage.current_company_id}`,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        project_id: projectId,
        markets: markets && markets.length ? markets.map(m => { return m.id; }).join(','): null,
        project_managers: project_managers && project_managers.length ? project_managers.map(pm => { return pm.id; }).join(',') : null,
        project_types: project_types && project_types.length ? project_types.map(pt => { return pt.id; }).join(','): null,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  deleteProjectFromTeam(projectId, teamId, eventMetadatum){
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: `${process.env.REACT_APP_API}/teams/${teamId}/remove_project?current_company=${localStorage.current_company_id}`,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        project_id: projectId,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  checkProjectUsage(teamId, projectId, options, eventMetadatum){
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'get',
      url: `${process.env.REACT_APP_API}/teams/${teamId}/check_project_usage?current_company=${localStorage.current_company_id}&project_id=${projectId}`,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
};

export default helpers;



// WEBPACK FOOTER //
// ./src/services/teamsService.js